import React, { useEffect } from "react";
import { MdCheckCircle, MdError } from "react-icons/md";
import style from "./ToastPopup.module.css";

/**
 * ToastPopup - A popup component for success/error messages (replaces browser alert)
 * @param {boolean} show - Whether to show the popup
 * @param {string} message - Message to display
 * @param {'success'|'error'} type - Type of message (success = green, error = red)
 * @param {function} onClose - Callback when popup is closed
 */
const ToastPopup = ({ show, message, type = "success", onClose }) => {
  useEffect(() => {
    if (show && onClose) {
      const timer = setTimeout(onClose, 4000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <>
      <div
        className={style.toastOverlay}
        onClick={onClose}
        role="presentation"
        aria-hidden="true"
      />
      <div
        className={`${style.toastPopup} ${type === "success" ? style.toastSuccess : style.toastError}`}
        role="alert"
      >
        <div className={style.toastIcon}>
          {type === "success" ? (
            <MdCheckCircle className={style.iconSuccess} />
          ) : (
            <MdError className={style.iconError} />
          )}
        </div>
        <p className={style.toastMessage}>{message}</p>
        <button
          className={`${style.toastButton} ${type === "success" ? style.toastButtonSuccess : style.toastButtonError}`}
          onClick={onClose}
          type="button"
          aria-label="Close"
        >
          OK
        </button>
      </div>
    </>
  );
};

export default ToastPopup;
